const RestrictedInput = require("components/forms/RestrictedInput");
const assign = require("object-assign");

class Phone extends RestrictedInput {

	normalize(value) {
		return (value[0] === "+" ? "+" : "") + value.replace(/[^0-9]/g, "");
	}

	get inputProps() {
		return assign(super.inputProps, {type: "text", pattern: "[0-9+]*"});
	}

}

module.exports = Phone;


// WEBPACK FOOTER //
// ./resources/js/components/forms/Phone.js